import React, { useState, useCallback } from "react";
import { Modal, ANNFinder } from "@ann/web-components";
import { observer } from "mobx-react";
import { useDrivesStores } from "../../hook/use-drives.hook";

const MoveFolderModal = ({
  size = "medium",
  modalWidth = "700px",
  modalHeight = "440px",
  isOpen,
  onClose,
  onSave,
  disabled = false,
}) => {
  const { myWorkspacesStore } = useDrivesStores();
  const [selectedId, setSelectedId] = useState("1");
  const [isMoving, setIsMoving] = useState(false);

  // Get the selected folder name
  const selectedFolder = myWorkspacesStore.folderList.find(
    (folder) => folder.folder_uuid === myWorkspacesStore.folderIdBeingMoved
  );
  const selectedFolderName = selectedFolder?.name || "Unknown Folder";

  const items = [
    { id: "1", name: "Selected Workspace", type: "workspace" },
    { id: "2", name: "Drive", type: "drive" },
    { id: "3", name: "Folder", type: "folder" },
  ];

  const handleItemClick = useCallback((item, newSelectedId) => {
    setSelectedId(newSelectedId);
  }, []);

  const handleMove = useCallback((selectedItem, targetItem) => {
    console.log("move", selectedItem, "to", targetItem);
    // tu lógica de mover aquí
  }, []);

  const handleSave = async () => {
    try {
      setIsMoving(true);

      // TODO: Implement the actual move logic here
      // This would typically involve calling a service to move the folder
      console.log("Moving folder to selected destination");

      onClose();
    } catch (error) {
      console.error("Error moving folder:", error);
    } finally {
      setIsMoving(false);
    }
  };

  const handleClose = () => {
    setIsMoving(false);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      width={modalWidth}
      height={modalHeight}
      size={size}
    >
      <Modal.Header>
        <Modal.Header.Title>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div>Move this folder</div>
            <span
              style={{
                marginTop: "4px",
                display: "block",
                fontSize: "16px",
                fontWeight: "normal",
              }}
            >
              {selectedFolderName}
            </span>
          </div>
        </Modal.Header.Title>
      </Modal.Header>
      <Modal.Body style={{ paddingBottom: "80px", marginBottom: "80px" }}>
        <ANNFinder
          items={items}
          selectedItemId={selectedId}
          onItemClick={handleItemClick}
          isMoving
          onSelectedItemToMove={handleMove}
        />
      </Modal.Body>
      <Modal.Actions
        align="end"
        style={{
          position: "absolute",
          bottom: "0",
          left: "0",
          right: "0",
          padding: "0",
          margin: "0",
          backgroundColor: "white",
          borderTop: "1px solid #e5e7eb",
            zIndex: 10,
          marginTop: "100px",
        }}
      >
        <Modal.Button label="Cancel" onClick={handleClose} type="secondary" />
        <Modal.Button
          label={isMoving ? "Moving..." : "Move to..."}
          onClick={handleSave}
          disabled={disabled || isMoving}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default observer(MoveFolderModal);

